import { useQuery } from "@tanstack/react-query";
import useRetryFetch from "./useRetryFetch";
import useAuth from "./useAuth";
import {
  getEngagementMetrics,
  type EngagementMetrics,
} from "../api/proactiveInsights";

export function useEngagementMetrics() {
  const retryFetch = useRetryFetch();
  const { auth } = useAuth();
  const isAuthenticated = !!auth?.accessToken;

  return useQuery<EngagementMetrics>({
    queryKey: ["engagement-metrics"],
    queryFn: () => getEngagementMetrics(retryFetch),
    staleTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
  });
}
